import { createSelector } from 'reselect'

import { NAME } from './reducer'

const byIdSelector = state => state[NAME].byId
const allKeysSelector = state => state[NAME].allKeys

export const getCategoryById = createSelector([byIdSelector], byId => id =>
  byId[id] || { icon: 'question.png', name: 'Missing Category' }
)

export const getCrimeCategories = createSelector(
  [getCategoryById, allKeysSelector],
  (byId, allKeys) => allKeys.map(byId)
)
